"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _updateNetworkHealth = require("./updateNetworkHealth");
Object.keys(_updateNetworkHealth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateNetworkHealth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _updateNetworkHealth[key];
    }
  });
});
var _networkHealthConfiguration = require("./networkHealthConfiguration");
Object.keys(_networkHealthConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _networkHealthConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _networkHealthConfiguration[key];
    }
  });
});